import React, { useState } from 'react';

const CollapsibleCard = (props) => {
  const [expanded, setExpanded] = useState(false);
  return (
    <div className="card is-fullwidth" style={{ minWidth: '100%' }}>
      <header
        className="card-header"
        style={{ cursor: 'pointer' }}
        onClick={() => {
          setExpanded(!!!expanded);
        }}
      >
        <p className="card-header-title">{props.title}</p>
        <a
          href={`#${props.id}`}
          data-action="collapse"
          className="card-header-icon is-hidden-fullscreen"
          aria-label="more options"
        >
          <span className="icon">
            <i className="fas fa-angle-down" aria-hidden="true"></i>
          </span>
        </a>
      </header>
      {expanded && (
        <div id={props.id} className="is-collapsible">
          <div style={{ padding: '20px' }}>{props.children}</div>
        </div>
      )}
    </div>
  );
};

export default CollapsibleCard;
